import React, { useEffect, useState } from 'react';
import './accessibility-panel.css';

const settings = [
  { key: 'largeText', label: 'Large text', className: 'a11y-large-text' },
  { key: 'highContrast', label: 'High contrast', className: 'a11y-high-contrast' },
  { key: 'reducedMotion', label: 'Reduce motion', className: 'a11y-reduced-motion' },
  { key: 'readableFont', label: 'Readable font', className: 'a11y-readable-font' },
];

const AccessibilityPanel = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(() => {
    try {
      const saved = window.localStorage.getItem('exhibition-accessibility');
      return saved
        ? JSON.parse(saved)
        : { largeText: false, highContrast: false, reducedMotion: false, readableFont: false };
    } catch {
      return { largeText: false, highContrast: false, reducedMotion: false, readableFont: false };
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    settings.forEach((setting) => {
      root.classList.toggle(setting.className, active[setting.key]);
      body.classList.toggle(setting.className, active[setting.key]);
    });
    window.localStorage.setItem('exhibition-accessibility', JSON.stringify(active));
  }, [active]);

  const toggle = (key) => {
    setActive((current) => ({ ...current, [key]: !current[key] }));
  };

  return (
    <aside className="accessibility-panel" aria-label="Accessibility tools">
      <button
        type="button"
        className="accessibility-trigger"
        aria-expanded={open}
        aria-controls="accessibility-options"
        onClick={() => setOpen((current) => !current)}
      >
        Access
      </button>

      {open && (
        <div className="accessibility-options" id="accessibility-options">
          <h2>Accessibility</h2>
          <p>Adjust the website display for easier reading and navigation.</p>
          {settings.map((setting) => (
            <button
              type="button"
              key={setting.key}
              className={active[setting.key] ? 'accessibility-option is-active' : 'accessibility-option'}
              aria-pressed={active[setting.key]}
              onClick={() => toggle(setting.key)}
            >
              <span>{setting.label}</span>
              <strong>{active[setting.key] ? 'On' : 'Off'}</strong>
            </button>
          ))}
          <button
            type="button"
            className="accessibility-reset"
            onClick={() => setActive({ largeText: false, highContrast: false, reducedMotion: false, readableFont: false })}
          >
            Reset settings
          </button>
        </div>
      )}
    </aside>
  );
};

export default AccessibilityPanel;
